import React, { lazy, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { Switch, Route } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';
import {
    getAllSubCategories,
    getMyServices,
} from '../../redux/services/servicesActions';
import { useSelector } from 'react-redux';

const Service = lazy(() => import('../../container/service'));
const EditService = lazy(() => import('../../container/service/editService'));
const AddService = lazy(() => import('../../container/service/addService'));

function ServiceRoutes() {
    const dispatch = useDispatch();
    const { userData } = useSelector((state) => state.user);
    const { path } = useRouteMatch();
    useEffect(() => {
        console.log('Undef==>', userData?.business?.id);
        dispatch(getAllSubCategories(userData?.business?.id));
        dispatch(getMyServices(2500));
    }, [dispatch]);
    return (
        <Switch>
            <Route path={`${path}/edit-service/:id`} component={EditService} />
            <Route path={`${path}/add-service`} component={AddService} />
            <Route path={path} component={Service} />
        </Switch>
    );
}

export default ServiceRoutes;
